import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-scroll-container',
  standalone: true,
  imports: [CommonModule],
  styles: `
    :host {
      @apply block h-full w-full flex-1;
    }
  `,
  host: { class: 'print-full-height' },
  template: `
    <div
      class="relative h-full w-full after:absolute after:inset-x-0 after:-top-[2px] after:mr-4 after:h-4 print:after:hidden"
      [ngClass]="{
        'after:bg-gradient-to-b after:from-20%': true,
        'after:from-white': !black,
        'after:from-black': black,
      }">
      <div class="print-full-height absolute inset-0 overflow-y-auto">
        <ng-content></ng-content>
      </div>
      <div
        class="after:absolute after:bottom-0 after:left-0 after:right-0 after:mr-4 after:h-4 print:after:hidden"
        [ngClass]="{
          'after:bg-gradient-to-b after:to-80%': true,
          'after:from-transparent': true,
          'after:to-white': !black,
          'after:to-black': black,
        }"></div>
    </div>
  `,
})
export class ScrollContainerComponent {
  @Input() black = false;
}
